export const logIntercomEvent = (event) => {
  // // https://docs.google.com/document/d/1c5zmeUsO3JsNwFrjITmziGclJ-A5ojGPdJP8QDIiGOE/edit
  window.Intercom('trackEvent', event)
}
